/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API SSO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AccessRightsPageableResponseDto } from '../models';
// @ts-ignore
import type { PageableRequestDto } from '../models';
// @ts-ignore
import type { PageableRequestWithUserIdDto } from '../models';
// @ts-ignore
import type { UserAccessRightsPageableResponseDto } from '../models';
/**
 * ACCESSRIGHTApi - axios parameter creator
 * @export
 */
export const ACCESSRIGHTApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение прав по userId
         * @param {PageableRequestWithUserIdDto} pageableRequestWithUserIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRightControllerGetAccessRightsByUserId: async (pageableRequestWithUserIdDto: PageableRequestWithUserIdDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageableRequestWithUserIdDto' is not null or undefined
            assertParamExists('accessRightControllerGetAccessRightsByUserId', 'pageableRequestWithUserIdDto', pageableRequestWithUserIdDto)
            const localVarPath = `/accessRight/getAccessRightsByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pageableRequestWithUserIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение всех прав
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRightControllerGetAllAccessRights: async (pageableRequestDto: PageableRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageableRequestDto' is not null or undefined
            assertParamExists('accessRightControllerGetAllAccessRights', 'pageableRequestDto', pageableRequestDto)
            const localVarPath = `/accessRight/getAllAccessRights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pageableRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение своих прав
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRightControllerGetMyAccessRights: async (pageableRequestDto: PageableRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageableRequestDto' is not null or undefined
            assertParamExists('accessRightControllerGetMyAccessRights', 'pageableRequestDto', pageableRequestDto)
            const localVarPath = `/accessRight/getMyAccessRights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pageableRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ACCESSRIGHTApi - functional programming interface
 * @export
 */
export const ACCESSRIGHTApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ACCESSRIGHTApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получение прав по userId
         * @param {PageableRequestWithUserIdDto} pageableRequestWithUserIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accessRightControllerGetAccessRightsByUserId(pageableRequestWithUserIdDto: PageableRequestWithUserIdDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAccessRightsPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accessRightControllerGetAccessRightsByUserId(pageableRequestWithUserIdDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ACCESSRIGHTApi.accessRightControllerGetAccessRightsByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение всех прав
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accessRightControllerGetAllAccessRights(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRightsPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accessRightControllerGetAllAccessRights(pageableRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ACCESSRIGHTApi.accessRightControllerGetAllAccessRights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение своих прав
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accessRightControllerGetMyAccessRights(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAccessRightsPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accessRightControllerGetMyAccessRights(pageableRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ACCESSRIGHTApi.accessRightControllerGetMyAccessRights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ACCESSRIGHTApi - factory interface
 * @export
 */
export const ACCESSRIGHTApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ACCESSRIGHTApiFp(configuration)
    return {
        /**
         * 
         * @summary Получение прав по userId
         * @param {PageableRequestWithUserIdDto} pageableRequestWithUserIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRightControllerGetAccessRightsByUserId(pageableRequestWithUserIdDto: PageableRequestWithUserIdDto, options?: RawAxiosRequestConfig): AxiosPromise<UserAccessRightsPageableResponseDto> {
            return localVarFp.accessRightControllerGetAccessRightsByUserId(pageableRequestWithUserIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение всех прав
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRightControllerGetAllAccessRights(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AccessRightsPageableResponseDto> {
            return localVarFp.accessRightControllerGetAllAccessRights(pageableRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение своих прав
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRightControllerGetMyAccessRights(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UserAccessRightsPageableResponseDto> {
            return localVarFp.accessRightControllerGetMyAccessRights(pageableRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ACCESSRIGHTApi - object-oriented interface
 * @export
 * @class ACCESSRIGHTApi
 * @extends {BaseAPI}
 */
export class ACCESSRIGHTApi extends BaseAPI {
    /**
     * 
     * @summary Получение прав по userId
     * @param {PageableRequestWithUserIdDto} pageableRequestWithUserIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ACCESSRIGHTApi
     */
    public accessRightControllerGetAccessRightsByUserId(pageableRequestWithUserIdDto: PageableRequestWithUserIdDto, options?: RawAxiosRequestConfig) {
        return ACCESSRIGHTApiFp(this.configuration).accessRightControllerGetAccessRightsByUserId(pageableRequestWithUserIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение всех прав
     * @param {PageableRequestDto} pageableRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ACCESSRIGHTApi
     */
    public accessRightControllerGetAllAccessRights(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig) {
        return ACCESSRIGHTApiFp(this.configuration).accessRightControllerGetAllAccessRights(pageableRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение своих прав
     * @param {PageableRequestDto} pageableRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ACCESSRIGHTApi
     */
    public accessRightControllerGetMyAccessRights(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig) {
        return ACCESSRIGHTApiFp(this.configuration).accessRightControllerGetMyAccessRights(pageableRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

